// extracted by mini-css-extract-plugin
module.exports = {"seleziona_giorno_container":"PacchettoCalendarioTipo1_seleziona_giorno_container__1ePcG"};